var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-section-card',[_c('base-text-preformatted',{attrs:{"value":_vm.message}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }